import { API_IMAGE_URL2 } from '../../lib/api';

export default function EmployeeList({ employees, selectedEmployee, onSelect, notifications }) {
  // Sort employees by latest notification count (high to low)
  const sortedEmployees = [...employees].sort((a, b) => {
    const notifA = notifications[a.id] || 0;
    const notifB = notifications[b.id] || 0;
    return notifB - notifA; // descending order
  });

  return (
    <div className="w-1/3 border-r overflow-y-auto text-center">
      <h3 className="p-2 font-semibold border-b">Emp</h3>
      <ul className="flex flex-col items-center">
        {sortedEmployees.map((emp) => (
          <li
            key={emp.id}
            className={`cursor-pointer flex flex-col items-center py-2 w-full rounded hover:bg-gray-100 ${
              selectedEmployee?.id === emp.id ? 'bg-blue-100' : ''
            }`}
            onClick={() => onSelect(emp)}
          >
            <img
              src={emp.profile_image ? `${API_IMAGE_URL2}${emp.profile_image}` : '/default-profile.png'}
              alt={emp.full_name}
              className="w-12 h-12 rounded-full object-cover"
            />
            <span className="mt-1 text-xs text-gray-800 font-medium text-center">
              {emp.full_name?.split(' ')[0]}
            </span>
            {notifications[emp.id] && (
              <span className="mt-1 text-white text-[10px] bg-red-600 px-2 py-0.5 rounded-full">
                {notifications[emp.id]}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
